/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const dailySeriesEntrySchema = z.object({
  addedCount: z.int(),
  date: z.iso.date(),
  netChange: z.int(),
  removedCount: z.int(),
});
